import 'styled-components/macro';
import React from 'react';

import { PickerButton } from './StyledElements';
import { formatDay, WeekdayTypes } from './service';

interface Props {
    date: string;
    isSelected: boolean;
    onSelect: (date: string) => void;
    locale: string;
}

export const DatePicker = ({ date, onSelect, isSelected, locale }: Props): React.ReactElement => {
    return (
        <PickerButton
            textAlign="center"
            isSelected={isSelected}
            disabled={isSelected}
            ariaPressed={isSelected}
            onClick={() => onSelect(date)}
        >
            {formatDay(date, undefined, locale, WeekdayTypes.SHORT)}
        </PickerButton>
    );
};
